import { gql } from '@apollo/client';

export const FETCH_USER_DATA = ({
  canReadLowRiskPii,
  canReadHighRiskPii,
}: {
  canReadLowRiskPii: boolean;
  canReadHighRiskPii: boolean;
}) => gql`
  query fetchUser($userId: SafeString!) {
    fetchUser(input: { userId: $userId }) {
      user {
        id: stringId
        ${canReadLowRiskPii ? 'firstName' : ''}
        ${canReadLowRiskPii ? 'middleName' : ''}
        ${canReadLowRiskPii ? 'lastName' : ''}
        ${canReadLowRiskPii ? 'affiliateOnly' : ''}
        ${canReadLowRiskPii ? 'primaryEmail' : ''}
        ${canReadLowRiskPii ? 'phone' : ''}
        ${canReadHighRiskPii ? 'dateOfBirth' : ''}
        ${canReadHighRiskPii ? 'gender' : ''}
        ${canReadHighRiskPii ? 'physicalAddress { city country houseNumber province neighborhood postal streetName unitNumber }' : ''}
        ${canReadLowRiskPii ? 'employmentStatus' : ''}
        ${canReadLowRiskPii ? 'companyType' : ''}
        ${canReadLowRiskPii ? 'jobTitle' : ''}
        ${canReadLowRiskPii ? 'studentAreaOfStudy' : ''}
        ${canReadLowRiskPii ? 'maritalStatus' : ''}
        ${canReadLowRiskPii ? 'citizenships' : ''}
        ${canReadLowRiskPii ? 'inProvinceSince' : ''}
        sinExists
     }
    }
  }
`;

export const CREATE_AFFILIATE = gql`
  mutation createAffiliate($input: CreateAffiliateInput!) {
    createAffiliate(input: $input) {
      user {
        id
      }
    }
  }
`;
export const FETCH_USERS = gql`
  query fetchUsers($input: FetchUsersInput!) {
    fetchUsers(input: $input) {
      users {
        id
      }
    }
  }
`;
export const UPDATE_AFFILIATE = gql`
  mutation updateAffiliate($input: UpdateAffiliateInput!) {
    updateAffiliate(input: $input) {
      user {
        id
      }
    }
  }
`;
export const UPDATE_USER = gql`
  mutation updateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      user {
        id
      }
    }
  }
`;
